import axios from "axios";
import Vue from 'vue';
import router from '../router'

import { EventBus } from "@/components/event-bus.js";

export const userService = {
  logIn,
  logOut
};

async function logIn(username, password) {
  let user = {};
  return axios
    .post(`${process.env.VUE_APP_API_URL}auth/login`, {
      username: username,
      password: password
    })
    .then(result => {
      if (result.data.auth_token) {
        localStorage.setItem('auth_token', result.data.auth_token);
      }
      // localStorage.setItem(
      //   "user",
      //   username
      // );

      // localStorage.setItem('roles',result.data.roles);
      // localStorage.setItem('auth_token',result.data.auth_token);

      // if (result.data.roles == "Administrator") {
      //   EventBus.$emit('isAdmin', true );  
      // }
      // else {
      //   EventBus.$emit('isAdmin', false );  
      // }

      // EventBus.$emit('isLogged', true );

      return result;
    })
    .catch(err => {
      console.log(err);
      EventBus.$emit('isLogged', false );
      return null;
    });
}



function logOut() {
  localStorage.clear();
  sessionStorage.clear();
  router.push('/login');
}
